/* Libs */
import Segment from '../index';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';

/* Types */
import { IHash } from 'types/base.types';

/**
 * -------------------------------------------------------------------------------------
 * Define the "event name" here, in TRACKING_TYPES
 */
export const TRACKING_TYPES = {
  searchResultsClicked: 'Results Clicked',
  searchEngaged: 'Search Engaged',
};

/**
 * -------------------------------------------------------------------------------------
 * These are just "actions" that are consolidated in one place that
 * will return your properties structure. Just "method" out what you
 * need to handle.
 */
export const SegmentTrackingAction = {
  search(searchAttributes: IHash<string | number | null | undefined | object>, type: string = TRACKING_TYPES.searchResultsClicked) {
    const filterAttributes = pickBy(searchAttributes, identity);
    const payload = {
      ...filterAttributes,
    };

    Segment.track(type, payload);
  },
};
